import { useMutation, useQueryClient } from "@tanstack/react-query";

import { enrollmentRequest } from "@/apiQueries/multisigEnrollment/multisigEnrollmentRequest";
import {
  MULTISIG_ENROLLMENT_QUERY_KEY,
  MULTISIG_ENROLLMENT_URL,
} from "@/apiQueries/multisigEnrollment/useMultisigEnrollment";
import { ORGANIZATION_MULTISIG_QUERY_KEY } from "@/apiQueries/multisigEnrollment/useOrganizationMultisig";

import type { EnrollmentError } from "@/helpers/enrollmentErrors";

import type { MultisigEnrollmentSession } from "@/types";

/** `POST /multisig/enrollment/keys/verify`. Posts the signed challenge; returns the updated session. */
export const useMultisigEnrollmentVerifyKey = () => {
  const queryClient = useQueryClient();

  return useMutation<MultisigEnrollmentSession, EnrollmentError, { signedChallengeXdr: string }>({
    mutationFn: (vars: { signedChallengeXdr: string }) =>
      enrollmentRequest<MultisigEnrollmentSession>(`${MULTISIG_ENROLLMENT_URL}/keys/verify`, {
        method: "POST",
        body: JSON.stringify({ signed_challenge_xdr: vars.signedChallengeXdr }),
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: MULTISIG_ENROLLMENT_QUERY_KEY });
      // Owner 2's verification is what finishes enrollment: the organization
      // flips to ENROLLED and the signer rows appear, so its own cache entry
      // (never refetched on focus) has to be refreshed too.
      void queryClient.invalidateQueries({ queryKey: ORGANIZATION_MULTISIG_QUERY_KEY });
    },
  });
};
